var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoGlobe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-globe",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 15.951,
    height: 15.951,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M9.819,2a7.819,7.819,0,1,0,7.819,7.819A7.819,7.819,0,0,0,9.819,2ZM7.494,3.794a7.956,7.956,0,0,0-.717,1.614l-.195.6,1.061.117.129-.394a4.465,4.465,0,0,1,1.452-2.34c.2-.018.395-.028.6-.028s.4.011.6.029a4.466,4.466,0,0,1,1.452,2.34l.129.394,1.061-.117-.195-.6a7.958,7.958,0,0,0-.717-1.615,6.5,6.5,0,0,1,3.3,2.862,27.461,27.461,0,0,1-5.578.535,28.845,28.845,0,0,1-5.678-.537A6.493,6.493,0,0,1,7.494,3.794ZM3.751,7.6a23.806,23.806,0,0,0,2.481.4,16.38,16.38,0,0,0-.1,1.812c0,.1,0,.907,0,1.043l1.019-.024c0-.113,0-.852,0-1.019a15.336,15.336,0,0,1,.1-1.713c.779.063,1.659.105,2.622.105.928,0,1.773-.039,2.521-.1a15.339,15.339,0,0,1,.094,1.706c0,.167,0,.905,0,1.02l1.019.023c0-.137,0-.94,0-1.042a16.372,16.372,0,0,0-.1-1.8,22.318,22.318,0,0,0,2.48-.41,6.449,6.449,0,0,1,.046,4.294,47.158,47.158,0,0,0-6.084-.31,48.681,48.681,0,0,0-6.142.31,6.449,6.449,0,0,1,.046-4.3Zm6.719,8.642a6.491,6.491,0,0,1-1.3,0,6.032,6.032,0,0,1-1.747-3.6c.71-.025,1.519-.041,2.428-.041.887,0,1.677.015,2.37.039A6.033,6.033,0,0,1,10.47,16.245Zm-6.34-3.37c.43-.049,1.185-.122,2.26-.18A9.555,9.555,0,0,0,7.5,15.844,6.5,6.5,0,0,1,4.13,12.874Zm8.01,2.97a9.561,9.561,0,0,0,1.109-3.152c1.08.057,1.833.131,2.26.181A6.5,6.5,0,0,1,12.139,15.845Z",
    transform: "translate(-1.637 -1.637)",
    fill: "#0071b9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGlobe);
export default __webpack_public_path__ + "static/media/ico-globe.51eed52c.svg";
export { ForwardRef as ReactComponent };